// extracted by mini-css-extract-plugin
export default {"del_area":"DelConfirm_del_area__X3U4W","del_title":"DelConfirm_del_title__9D2ov","del_desc":"DelConfirm_del_desc__kaPII"};